// @ts-strict-ignore
import { ReportType } from 'constants/reports/report-type';
import { ApiManager } from 'services/api/api-manager';
import { type IActionWithPayload } from 'store/helper';

import { type IFetchReportPayload, type IReportRequest, ReportRequestName } from '../interfaces';

import { makeFetchingSaga } from './helpers';

export function* fetchAchievedGoals(action: IActionWithPayload<string, IFetchReportPayload>) {
  const requests: IReportRequest[] = [
    {
      name: ReportRequestName.Goals,
      interface: ApiManager.reportApi.fetchGoals,
    },
  ];

  yield makeFetchingSaga(ReportType.Goals, action, requests);
}
